import Image1 from '../../assets/project1.jpg'
import Image2 from '../../assets/project2.jpg'
import Image3 from '../../assets/project3.jpg'
import Image4 from '../../assets/project4.jpg'
import Image5 from '../../assets/project5.jpg'
import Image6 from '../../assets/project6.jpg'
import Image7 from '../../assets/project7.jpg'
import Image8 from '../../assets/project8.jpeg'
import Image9 from '../../assets/project9.jpg'

const data = [
    {
        id: 1,
        category: 'frontend',
        image: Image1,
        title: "Rythmz Music App",
        desc: "The React Music App is a cutting-edge music streaming app that aims to provide an enhanced user experience while enjoying your favorite tunes. This app is built using React, Tailwind CSS, Redux, and integrates with RapidAPI to access a vast library of music content.",
        demo: 'https://rythmz.netlify.app/',
        github: 'https://github.com/alexamankwah2/rythmz'
    },
    {
        id: 2,
        category: 'frontend',
        image: Image2,
        title: "Genie 2.0",
        desc: "This is a web application built with React and Tailwind CSS for the frontend and powered by OpenAI and nodejs. The app leverages the powerful natural language processing capabilities of OpenAI to provide intelligent and dynamic responses to user inputs. ",
        demo: 'https://genie2.website/',
        github: 'https://github.com/alexamankwah2/genie'
    },
    {
        id: 3,
        category: 'full stack',
        image: Image3,
        title: "AI-Imager",
        desc: "This is a full-stack AI-powered image generation application built using the MERN (MongoDB, Express, React, Node.js) stack. The frontend is developed with React and Tailwind CSS, while the backend utilizes Node.js with Express for server-side logic and MongoDB for data storage.",
        demo: 'https://ai-imager1.com/',
        github: 'https://github.com/alexamankwah2/ai-imager-react'
    },
    {
        id: 4,
        category: 'full stack',
        image: Image4,
        title: "Pizza Ordering App",
        desc: "A full-stack web application built using Next.js and MongoDB. This app allows users to order delicious pizzas online and pay with PayPal. With its intuitive user interface and seamless payment integration, it provides a smooth pizza ordering experience",
        demo: 'https://github.com/alexamankwah2/pizza-order',
        github: 'https://github.com/alexamankwah2/pizza-order'
    },
    {
        id: 5,
        category: 'frontend',
        image: Image5,
        title: "Notes App",
        desc: "This is a simple web application built with React.js that allows users to create, edit, and delete notes. It provides an intuitive and user-friendly interface for managing your personal notes, making it easy to keep track of your thoughts, ideas, and to-do lists.",
        demo: 'https://notepad-498.pages.dev/',
        github: 'https://github.com/alexamankwah2/notes-react'
    },
    {
        id: 6,
        category: 'frontend',
        image: Image6,
        title: "React Weather App",
        desc: "This is a simple web application built with React that allows users to check the weather forecast for a specific location using the OpenWeather API. With this app, users can stay informed about the current weather conditions  and more for their desired location.",
        demo: 'https://react-weatherapp.pages.dev/',
        github: 'https://github.com/alexamankwah2/React-WeatherApp'
    },
    {
        id: 7,
        category: 'frontend',
        image: Image7,
        title: "Fitness Website (landing page)",
        desc: "This is a responsive gym website landing page built using ReactJS. The landing page is designed to showcase the gym's features, facilities, and classes to attract potential customers. It is fully responsive and optimized for various devices, ensuring a seamless user experience.",
        demo: 'https://getfitclub.pages.dev/',
        github: 'https://github.com/alexamankwah2/fitness-page'
    },
    {
        id: 8,
        category: 'frontend',
        image: Image8,
        title: "Mystic Match",
        desc: "A React memory game with a turn count! This is a classic memory-testing game built using React, where players are challenged to match pairs of cards in the fewest turns possible. The game keeps track of the number of turns taken to complete the game, adding an extra layer of challenge.",
        demo: 'https://mysticmatch.pages.dev/',
        github: 'https://github.com/alexamankwah2/mystic-match'
    },
   
]


export default data